// extracted by mini-css-extract-plugin
export var legendIndicator = "_94-1";
export var legendRight = "_94-0";